class MainProduct extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.updateCartCount();
    this.initializeForm();
    this.handleSwiper();
    this.zoomImage();

    this.productAddedContainer = this.querySelector(
      ".main-product__product-added-msg"
    );
    this.productAddedMessage = this.querySelector(
      ".main-product__product-added"
    );
    this.productName = this.getAttribute("data-product-name");
    this.productAddedIcon = this.querySelector(".main-product__check-icon");
    this.loaderIconAnimation = this.querySelector(".main-product__loader-icon");
    this.submitFormBtn = this.querySelector(".product__submit");
    this.tabNavigation = this.querySelectorAll(".content-tabs__nav li");
    this.accordionContainer = this.querySelector(".main-product__accordion");
    this.accordionTabs = document.querySelectorAll("tbody");
    this.renderAccordion(this.accordionTabs);
    this.variantButtons = this.querySelectorAll(".variant-button");

    this.productHandle = this.getAttribute("data-product-handle");
    this.fetchProductData();
    this.selectedVariantId = null;
    this.productPrice = this.querySelector(".main-product__price");
  }

  fetchProductData() {
    fetch(`/products/${this.productHandle}.js`)
      .then((response) => {
        if (!response.ok) throw new Error("Network response was not ok");
        return response.json();
      })
      .then((product) => {
        this.product = product;
        this.updateProductVariants();
        this.setDefaultSelections();
      })
      .catch((error) => {
        console.error("Error fetching product data:", error);
      });
  }

  setDefaultSelections() {
    const variantButtons = this.querySelectorAll(".variant-button");
    const optionGroups = {};
    variantButtons.forEach((button) => {
      const optionName = button.getAttribute("data-option-name");
      if (!optionGroups[optionName]) {
        optionGroups[optionName] = button;
      }
    });

    for (const optionName in optionGroups) {
      optionGroups[optionName].classList.add("selected");
    }

    this.updateSelectedVariant();
  }

  initializeForm() {
    const form = this.querySelector("#main-product-form");
    const quantityInput = this.querySelector("#product-quantity");
    const increaseButton = this.querySelector("#increase-quantity");
    const decreaseButton = this.querySelector("#decrease-quantity");

    form.addEventListener("submit", (submitEvent) => {
      submitEvent.preventDefault();
      const quantity = parseInt(quantityInput.value);
      this.addToCart(this.selectedVariantId, quantity);
    });

    quantityInput.value = 1;

    increaseButton.addEventListener("click", () => {
      quantityInput.value = parseInt(quantityInput.value) + 1;
    });

    decreaseButton.addEventListener("click", () => {
      if (quantityInput.value > 1) {
        quantityInput.value = parseInt(quantityInput.value) - 1;
      }
    });
  }

  addToCart(variantId, quantity) {
    if (!variantId) {
      console.error("Cannot add to cart, no variant selected.");
    }

    this.submitFormBtn.setAttribute("disabled", "");
    this.showLoadingSpinner();

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: quantity,
          },
        ],
      }),
    })
      .then((response) => {
        if (!response.ok) throw new Error("Network response was not ok");
        this.productAdded();
        this.hideLoadingSpinner();
        return response.json();
      })
      .then(() => {
        this.updateCartCount();
      })
      .catch((error) => {
        console.error("Error adding product to cart:", error);
      });
  }

  updateCartCount() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const cartCountBubble = document.querySelector(".cart-count-bubble");
        cartCountBubble.innerText = cart.item_count;
        cartCountBubble.style.display = cart.item_count > 0 ? "flex" : "none";
      })
      .catch((error) => {
        console.error("Error fetching cart count:", error);
      });
  }

  productAdded() {
    this.productAddedContainer.classList.add("show");
    this.productAddedMessage.innerHTML = `${this.productName} has been added to the cart`;

    this.productAddedIcon.style.display = "block";

    setTimeout(() => {
      this.productAddedIcon.style.display = "none";
    }, 1000);
  }

  showLoadingSpinner() {
    this.productAddedIcon.style.display = "none";
    this.loaderIconAnimation.style.display = "flex";
  }

  hideLoadingSpinner() {
    this.submitFormBtn.removeAttribute("disabled");
    this.loaderIconAnimation.style.display = "none";
  }

  zoomImage() {
    const zoomContainers = this.querySelectorAll(".zoom-container");
    zoomContainers.forEach((zoomContainer) => {
      const zoomImage = zoomContainer.querySelector(".zoom-image");

      zoomContainer.addEventListener("mousemove", (e) => {
        const rect = zoomContainer.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        const xPercent = (x / zoomContainer.offsetWidth) * 100;
        const yPercent = (y / zoomContainer.offsetHeight) * 100;

        zoomImage.style.transformOrigin = `${xPercent}% ${yPercent}%`;
        zoomImage.style.transform = `scale(2)`;
      });

      zoomContainer.addEventListener("mouseleave", () => {
        zoomImage.style.transformOrigin = "center center";
        zoomImage.style.transform = "scale(1)";
      });
    });
  }

  handleSwiper() {
    document.addEventListener("DOMContentLoaded", () => {
      this.swiper = new Swiper(".main-product__swiper", {
        loop: false,
        autoplay: false,

        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });

      this.addSmallImageClickListeners();
    });
  }

  addSmallImageClickListeners() {
    const smallImages = document.querySelectorAll(".main-product__small-image");

    smallImages.forEach((element, index) => {
      element.addEventListener("click", () => {
        this.swiper.slideTo(index);
      });
    });
  }

  renderAccordion(tabBody) {
    let currentTab = "";

    tabBody.forEach((body) => {
      const tr = body.querySelectorAll("tr");

      tr.forEach((row, index) => {
        if (index === 0) {
          currentTab = row.innerHTML.replace(/(&nbsp;){2,}/g, " ");
          this.accordionContainer.innerHTML += `
            <div class="main-product__tab-name f-bold"><p>${currentTab}</p>
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
            </div>
            <div class="main-product__tab-content"></div>
          `;
        } else if (index === 1) {
          let tabText = row.innerText;
          let tabContent = this.accordionContainer.querySelector(
            ".main-product__tab-content:last-child"
          );
          tabContent.innerHTML += `
            ${tabText}
          `;
        } else {
          let tabContent = this.accordionContainer.querySelector(
            ".main-product__tab-content:last-child"
          );
          tabContent.innerHTML += ` ${row.innerText}
          `;
        }
      });
    });

    const contentTab = this.querySelectorAll(".main-product__tab-name");

    contentTab.forEach((el) => {
      el.addEventListener("click", () => {
        contentTab.forEach((el) => {
          el.nextElementSibling.classList.remove("active");
        });
        el.nextElementSibling.classList.add("active");
      });
    });
  }

  updateProductVariants() {
    this.variantMap = {};
    this.product.variants.forEach((variant) => {
      const optionKeys = variant.options
        .map((option) => option.toLowerCase().trim())
        .join("-");

      const price = Shopify.formatMoney(variant.price);

      this.variantMap[optionKeys] = {
        id: variant.id,
        price: price,
      };
    });

    let variantButtons = this.querySelectorAll(".variant-button");
    variantButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const optionName = button.getAttribute("data-option-name");
        variantButtons.forEach((btn) => {
          if (btn.getAttribute("data-option-name") === optionName) {
            btn.classList.remove("selected");
          }
        });

        button.classList.add("selected");
        this.updateSelectedVariant();
        const selectedKey = this.getSelectedOptionsKey();
        const selectedVariant = this.variantMap[selectedKey];
        if (selectedVariant) {
          const priceElement = this.querySelector(".main-product__price");
          if (priceElement) {
            priceElement.innerText = selectedVariant.price;
          }
        }
      });
    });
  }

  getSelectedOptionsKey() {
    let selectedOptions = [];
    const variantButtons = this.querySelectorAll(".variant-button");

    variantButtons.forEach((btn) => {
      if (btn.classList.contains("selected")) {
        const optionVal = btn
          .getAttribute("data-option-value")
          .toLowerCase()
          .trim();
        selectedOptions.push(optionVal);
      }
    });

    return selectedOptions.join("-");
  }

  updateSelectedVariant() {
    const selectedKey = this.getSelectedOptionsKey();
    const selectedVariant = this.variantMap[selectedKey];

    if (selectedVariant) {
      this.selectedVariantId = selectedVariant.id;
      const variantIndex = this.product.variants.findIndex(
        (variant) => variant.id === this.selectedVariantId
      );

      if (variantIndex !== -1) {
        this.swiper.slideTo(variantIndex);
      }
    } else {
      this.selectedVariantId = this.dataset.variantId;
    }
  }
}

customElements.define("main-product", MainProduct);
